import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import _, { transform } from 'lodash';

import { WithStyles, createStyles, Typography, Button, Modal, Card, CardContent, CardActions, CardHeader, IconButton, FormControl, InputLabel, Select, MenuItem, Grid, Paper, Link, TableHead, Table, TableBody, TextField, Fade, Popper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { id } from 'date-fns/locale';
import { MyPATTextArea } from '../../common';
import { CheckCircle } from '@material-ui/icons';
import PerfectScrollbar from 'react-perfect-scrollbar';
const styles = (theme: Theme) => createStyles({
    // cards Author and Student
    feedbackPanel: {
        padding: '10px 12px!important',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
        border: '1px solid #1D7DEA',
        width: 292,
        zIndex: 9,
        '&:nth-child': {
            '& input': {
                backgroundColor: '#EFF7FF'
            }
        },
        '&::after,&::before': {
            borderLeft: '16px solid transparent',
            borderRight: '16px solid transparent',
            borderTop: '16px solid #fff',
            top: 21,
            content: '" "',
            left: '-4px',
            marginLeft: -16,
            position: 'absolute',
            transform: 'rotate(90deg)'
        },
        '&::before': {
            borderLeft: '13px solid transparent',
            borderRight: '13px solid transparent',
            borderTop: '13px solid',
            borderTopColor: 'inherit',
            top: '22px',
            marginLeft: '-16px',
        },
    },
    placeholderTxt: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        fontSize: '14px!important',
        color: '#fff',
        textAlign: 'center',
        padding: '3px',
        textTransform: 'capitalize',
        '&>:first-child': {
            fontSize: '14px!important'
        },
        '&>span': {
            fontSize: '14px!important'
        }
    },
    purpleColor: {
        background: '#CE9AF6'
    },
    greenColor: {
        background: '#379D0B'
    },
    blueColor: {
        background: '#75A6DE'
    },
    yellowColor: {
        background: '#FDCA8C'
    },
    redColor: {
        background: '#FFB6B6'
    },
    mt5: {
        marginTop: '5px',
        '&>:first-child': {
            fontWeight: 400
        }
    },
    FeedbackIcon: {
        position: 'relative',
        '&>span:first-child': {
            marginLeft: -10,
            display: "block",
        }
    },
    feedbackContent: {
        fontWeight: 400,
        fontSize: '14px!important',
        lineHeight: '140%',
        color: '#333',
        width: '100%',
        paddingLeft: 10,
        // overflow: 'hidden',
        // textOverflow: 'ellipsis',
        whiteSpace: 'pre-wrap',
        display: 'inline-block',
        '&>:first-child': {
            fontSize: '14px!important'
        },
    },
    customTextarea: {
        background: '#EFF7FF',
        border: '1px solid #EFF7FF',
        borderRadius: 4,
        padding: 0,
        '&>:first-child': {
            backgroundColor: '#EFF7FF',
            fontSize: "14px !important",
            fontWeight: 'normal !important' ,
            padding: "12px !important",
            '&::placeholder': {
                fontSize: 12,
                color: '#999',
                fontStyle: 'italic',
                fontWeight: 'normal',
                opacity: 1,
            },
        } ,
    } as React.CSSProperties,
    inputArea: {
        '&>:first-child': {
            fontWeight: 400,
            '&>:first-child': {
                border: 0,
            }
        }
    },
    borderB: {
        borderBottom: '0.54px solid #D3D3D3',
        padding: '12px 0',
        '&>:last-child': {
            border: 0,
        },
        '&>:nth-child(2)': {
            '&>:first-child': {
                '&>:first-child': {
                    '&>:first-child': {
                        fontWeight: 400,
                        verticalAlign:3,
                        marginLeft:10,
                    },
                },
            },
        },
    },
    viewMore: {
        fontSize: '14px!important',
        fontWeight: 600,
        color: '#1d7dea',
        textAlign: 'center',
    },
    maxHeight: {
        maxHeight: 218,
        display: 'inline-block',
        width: '100%',
        '&>:first-child': {
            '&>:last-child': {
                borderBottom: '0',
                paddingBottom: 40,
            }
        }
    },
    normalTxt: {
        fontSize: '14px!important',
        lineHeight: '19px',
        fontWeight: 400,
    },
    colorGray: {
        color: '#666',
    },
    colorGreen: {
        color: '#30BE76'
    },
    colorBlack: {
        color: '#000'
    },
    btnGray: {
        fontSize: '14px!important',
        color: '#666',
        fontWeight: 600,
        '&>span': {
            fontSize: '14px!important',
        }
    },
    btnPrimary: {
        fontSize: '14px!important',
        color: '#1d7dea',
        fontWeight: 600,
        '& span': {
            fontSize: '14px!important',
        }
    },
    textRight: {
        textAlign: 'right',
        '&>svg': {
            verticalAlign: 'bottom'
        }
    },
    ReplyComment: {
        overflow: 'hidden',
        // '&>:nth-last-child(-n+2)':{
        //     borderBottom: '0',
        //     paddingBottom: 0,
        // }
    }
});

//@ts-ignore
interface AddFeedbackProps extends WithStyles<typeof styles> {
    classes: any,
    addNewFeedback: Function,
    resolveFeedback: Function,
    closeFeedback: Function,
    replyFeedback: Function,
    clickedfeedbackData: any,
    author: string
}



interface AddFeedbackStates {
    feedbackText: string

}

class AddFeedback extends Component<AddFeedbackProps, AddFeedbackStates>{
    constructor(props: AddFeedbackProps) {
        super(props);
        this.state = {
            feedbackText: ''
        }
    }

    addFeedbackInPreview(event: any) {
        this.handleParentClick(event)
        if (this.state.feedbackText !== '') {
            this.props.addNewFeedback(this.state.feedbackText)
        }
    }
    closeFeedback(event: any) {
        this.handleParentClick(event);
        this.props.closeFeedback()
    }
    resolveFeedbackInPreview(event: any) {
        this.handleParentClick(event);
        if(this.state.feedbackText) {
            this.addReplyInPreview(event);
        }
        this.props.resolveFeedback(this.props.clickedfeedbackData._id);
    }
    addReplyInPreview(event: any) {
        this.handleParentClick(event)
        this.props.replyFeedback(this.props.clickedfeedbackData._id, this.state.feedbackText);

    }
    handleText = (event: any) => {
        event.stopPropagation();
        this.setState({ feedbackText: event.target.value });
    }
    handleParentClick = (event: any) => {
        event.stopPropagation();
    }

    getProfileColor(user: string) {
        const { classes } = this.props;
        switch (user) {
            case 'evaluator':
                return [classes.placeholderTxt, classes.greenColor].join(" ")
            case 'creator':
                return [classes.placeholderTxt, classes.purpleColor].join(" ")
            case 'languageEvaluator':
                return [classes.placeholderTxt, classes.yellowColor].join(" ")
            case 'moderator':
                return [classes.placeholderTxt, classes.blueColor].join(' ')
            case 'publisher':
                return [classes.placeholderTxt, classes.redColor].join(" ")
        }

    }

    render() {
        const { classes, clickedfeedbackData, author } = this.props;
        return (
            <>
            {((_.isEmpty(clickedfeedbackData) && author !== 'creator') || !_.isEmpty(clickedfeedbackData) )&&
                <Paper className={classes.feedbackPanel}>
                    <Grid container>
                        <Grid item xs={6}>
                            <Typography className={[classes.normalTxt, classes.colorGray].join(' ')}>Feedback</Typography>
                        </Grid>
                        {clickedfeedbackData && clickedfeedbackData.isResolved && <Grid item xs={6} className={[classes.normalTxt, classes.colorGreen, classes.textRight].join(' ')}>
                            Resolved <CheckCircle />
                        </Grid>}
                        <Grid container>
                            {clickedfeedbackData && clickedfeedbackData.topic &&
                                <Grid item xs={12} className={classes.ReplyComment}>
                                    <Grid container alignItems="center" className={classes.borderB}>
                                        <Grid item xs={1}>
                                            <Grid className={this.getProfileColor(clickedfeedbackData.topic.user.role)}><span>{clickedfeedbackData.topic.user.role.charAt(0)}</span></Grid>
                                        </Grid>
                                        <Grid item xs={11}>
                                            <Grid className={classes.profileContent}>
                                                <Typography className={classes.mt5}>
                                                    <span className={classes.feedbackContent}>{clickedfeedbackData.topic.value}</span>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {/* Comments */}
                                    <PerfectScrollbar>
                                        <Grid className={classes.maxHeight}>
                                            {clickedfeedbackData && clickedfeedbackData.comments && clickedfeedbackData.comments.length > 0 && <Grid container alignItems="center">

                                                {clickedfeedbackData.comments.map((comment: any, index: any) => {
                                                    return (

                                                        <Grid container alignItems="center" className={classes.borderB}>
                                                            <Grid item xs={1}>
                                                                <Grid className={this.getProfileColor(comment.user.role)}><span>{comment.user.role.charAt(0)}</span></Grid>
                                                            </Grid>
                                                            <Grid item xs={11}>
                                                                <Grid className={classes.profileContent}>
                                                                    <Typography>
                                                                        <span className={classes.feedbackContent}>{comment.value}</span>
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                    );
                                                })}

                                            </Grid>}
                                        </Grid>
                                    </PerfectScrollbar>
                                    {/* End */}
                                </Grid>}
                            {((!_.isEmpty(clickedfeedbackData) && !clickedfeedbackData.isResolved) || _.isEmpty(clickedfeedbackData)) && <Grid item xs={12} className={classes.inputArea}>
                                <MyPATTextArea
                                    className={classes.customTextarea}
                                    onClick={this.handleParentClick.bind(this)}
                                    onChange={this.handleText.bind(this)}
                                    value={this.state.feedbackText}
                                    multiline
                                    fullWidthControl
                                    rows="4"
                                    inputProps={{
                                        maxlength: 180
                                    }}
                                    placeholder="Write your remarks here"
                                />
                            </Grid>}
                            {_.isEmpty(clickedfeedbackData) && <Grid container justify="flex-end">
                                <Button className={classes.btnGray} onClick={this.closeFeedback.bind(this)}>Cancel</Button>
                                <Button color="primary" className={classes.btnPrimary} onClick={this.addFeedbackInPreview.bind(this)} disabled={this.state.feedbackText === ''}>Submit</Button>
                            </Grid>}
                            {!_.isEmpty(clickedfeedbackData) && !clickedfeedbackData.isResolved && <Grid container justify="flex-end">
                                <Button className={classes.btnGray} onClick={this.addReplyInPreview.bind(this)} 
                                    disabled={this.state.feedbackText === ''}>Reply</Button>
                                <Button color="primary" className={classes.btnPrimary} onClick={this.resolveFeedbackInPreview.bind(this)}>Resolve</Button>
                            </Grid>}
                        </Grid>
                    </Grid>
                </Paper>
           }
            </>
        );

    }

}
const mapStateToProps = (state: any) => ({
});
const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
    },
    dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddFeedback));

